
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class MoldMasterDialog extends Serenity.EntityDialog<MoldMasterRow, any> {
        protected getFormKey() { return MoldMasterForm.formKey; }
        protected getIdProperty() { return MoldMasterRow.idProperty; }
        protected getLocalTextPrefix() { return MoldMasterRow.localTextPrefix; }
        protected getNameProperty() { return MoldMasterRow.nameProperty; }
        protected getService() { return MoldMasterService.baseUrl; }
        protected getDeletePermission() { return MoldMasterRow.deletePermission; }
        protected getInsertPermission() { return MoldMasterRow.insertPermission; }
        protected getUpdatePermission() { return MoldMasterRow.updatePermission; }

        protected form = new MoldMasterForm(this.idPrefix);

    }
}